import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Chart from "react-apexcharts";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { getMonthlyIndustryRevenueReport } from "../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../Utils/restUtils";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";

const MonthlyRevenueByIndustry = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const currentYear = new Date().getFullYear();
  const [revenuData, setRevenuData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [isIndustry, setIsIndustry] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [chartCategories, setChartCategories] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);
  const revenuColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      width: "80px",
      center:true
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.Industry,
      minWidth: "180px",
      wrap: true,
    },
    {
      name: <H4>January</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.January}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>February</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.February}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>March</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.March}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>April</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.April}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>May</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.May}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>June</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.June}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>July</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.July}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>August</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.August}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>September</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.September}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>October</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.October}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>November</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.November}</span>
      ),
      width: "120px",
    },
    {
      name: <H4>December</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.December}</span>
      ),
      width: "120px",
    },
  ];

  useEffect(() => {
    revenuIndustryData(1, perPage, {});
  }, []);

  const getYearOption = () => {
    const startYear = 2022;
    const currentYear = new Date().getFullYear();
    const endYear = currentYear;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };
  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    revenuIndustryData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    revenuIndustryData(page, newPerPage, appliedFilters);
  };

  const handleFilter = () => {
    const filters = {
      search: tempSearch,
      industry_type_id: isIndustry?.value || "",
      year: selectedYear || "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);

    revenuIndustryData(1, perPage, filters);
  };

  const revenuIndustryData = async (page = 1, size = perPage, filters = {}) => {
    setLoading(true);

    try {
      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        year: filters.year || "",
      }).toString();

      const res = await getDataWithToken(
        `${getMonthlyIndustryRevenueReport}?${query}`,
      );

      const formattedData = res.data.data.map((e, index) => ({
        Sl: (page - 1) * size + index + 1,
        Industry: e.industry,
        January: e.Jan,
        February: e.Feb,
        March: e.Mar,
        April: e.Apr,
        May: e.May,
        June: e.Jun,
        July: e.Jul,
        August: e.Aug,
        September: e.Sep,
        October: e.Oct,
        November: e.Nov,
        December: e.Dec,
      }));

      setRevenuData(formattedData);
      setTotalRows(res.data.total || 0);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      setChartCategories(months);

      const series = formattedData.map((item) => ({
        name: item.Industry,
        data: [
          item.January,
          item.February,
          item.March,
          item.April,
          item.May,
          item.June,
          item.July,
          item.August,
          item.September,
          item.October,
          item.November,
          item.December,
        ],
      }));

      setChartSeries(series);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const fetchExportData = async () => {
    const query = new URLSearchParams({
      export: "monthly_industry_revenue",
      search: appliedFilters.search || "",
      industry_type_id: appliedFilters.industry_type_id || "",
      year: appliedFilters.year || "",
    }).toString();

    const res = await getDataWithToken(
      `${getMonthlyIndustryRevenueReport}?${query}`,
    );

    return res?.data || [];
  };
  const exportPDF = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();

      const doc = new jsPDF("l", "mm", "a4"); // landscape (important!)

      const rows = data.map((e, index) => [
        index + 1,
        e.industry,
        e.Jan,
        e.Feb,
        e.Mar,
        e.Apr,
        e.May,
        e.Jun,
        e.Jul,
        e.Aug,
        e.Sep,
        e.Oct,
        e.Nov,
        e.Dec,
      ]);

      autoTable(doc, {
        head: [
          [
            "Sl",
            "Industry",
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        ],
        body: rows,
        styles: { fontSize: 7 },
      });

      doc.save("monthly_revenue_by_industry.pdf");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const exportExcel = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();

      const formatted = data.map((e, index) => ({
        Sl: index + 1,
        Industry: e.industry,
        January: e.Jan,
        February: e.Feb,
        March: e.Mar,
        April: e.Apr,
        May: e.May,
        June: e.Jun,
        July: e.Jul,
        August: e.Aug,
        September: e.Sep,
        October: e.Oct,
        November: e.Nov,
        December: e.Dec,
      }));

      const ws = XLSX.utils.json_to_sheet(formatted);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Monthly Revenue");

      XLSX.writeFile(wb, "monthly_revenue_by_industry.xlsx");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Monthly Revenue By Industry"
        parent="Report"
        title="Monthly Revenue By Industry"
      />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <H3>Monthly Revenue By Industry Report</H3>

          <Dropdown
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}
          >
            <DropdownToggle
              className="btn btn-primary"
              color="#fff"
              style={{ fontSize: "14px", zIndex: 1000 }}
            >
              Export <i className="icofont icofont-arrow-up"></i>
            </DropdownToggle>

            <DropdownMenu container="body">
              <DropdownItem onClick={exportExcel}>
                <i className="fa fa-file-excel-o me-2"></i> Excel
              </DropdownItem>

              <DropdownItem onClick={exportPDF}>
                <i className="fa fa-file-pdf-o me-2"></i> PDF
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col m="12" md="6" lg="3">
                <select
                  className="form-select select-dashboard"
                  defaultValue={currentYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {getYearOption().map((year) => {
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
              </Col>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>

          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="mb-4">
          <Chart
  options={{
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },

    colors: ["#4F46E5", "#22C55E", "#EF4444", "#F59E0B", "#3B82F6"],

    stroke: {
      curve: "smooth",
      width: 3,
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 90, 100],
      },
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      borderColor: "#e7e7e7",
      strokeDashArray: 4,
    },

    xaxis: {
      categories: chartCategories,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },

    yaxis: {
      labels: {
        formatter: (val) => `₹ ${val}`,
      },
    },

    tooltip: {
      y: {
        formatter: (val) => `₹ ${val}`,
      },
    },

    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "13px",
    },

    markers: {
      size: 4,
      hover: {
        size: 6,
      },
    },
  }}
  series={chartSeries}
  type="area"
  height={320}
/>
          </div>
          <div className="order-history table-responsive">
            <DataTable
              columns={revenuColumns}
              data={revenuData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default MonthlyRevenueByIndustry;
